import * as React from "react";
import { RouteComponentProps } from "react-router";

import { MY_CLEANINGS_MODALS } from "@typings/clientDashboard";

import { ImpersonatorNotification } from "@ui/Molecules/ImpersonatorNotification";

import { useAuth } from "@hooks/useAuth";
import { useModalManager } from "@hooks/modal";

import { useUserNotifications } from "@app/hooks/useUserNotifications";

import { ChecklistWarning } from "./ChecklistWarning";
import { OptionsDashboardModals } from "./OptionsDashboard.modals";

import { ClientDashboardView } from "./";

const ClientDashboard = (props: RouteComponentProps): React.ReactElement => {
  const { isAdminImpersonator, isUserAdmin } = useAuth();
  const { userNotifications } = useUserNotifications();
  const { isModalActive } = useModalManager();

  if (isUserAdmin && !isAdminImpersonator) {
    return <ImpersonatorNotification />;
  }

  return (
    <React.Fragment>
      <ClientDashboardView
        currentUrl={props.match.url}
        bookingsToValidate={userNotifications.hasBookingsToValidate}
      />
      {isModalActive(MY_CLEANINGS_MODALS.CHECKLIST_WARNING) && (
        <ChecklistWarning />
      )}
      <OptionsDashboardModals />
    </React.Fragment>
  );
};

export { ClientDashboard };
